import { AlertTriangle, Info, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  type = 'warning',
  title,
  message,
  confirmText,
  cancelText,
  submitting = false,
  children,
}) {
  const { lang } = useLanguage();

  if (!isOpen) return null;

  const iconColor = {
    warning: 'text-amber-600',
    danger: 'text-red-600',
    info: 'text-blue-600',
    success: 'text-green-600',
  }[type];

  const buttonColor = {
    warning: 'bg-amber-600 hover:bg-amber-700',
    danger: 'bg-red-600 hover:bg-red-700',
    info: 'bg-blue-600 hover:bg-blue-700',
    success: 'bg-green-600 hover:bg-green-700',
  }[type];

  const IconComponent = type === 'info' ? Info : AlertTriangle;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !submitting) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4"
      onClick={handleOverlayClick}
      data-testid="confirm-modal"
    >
      <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl">
        <div className="flex items-start gap-3 mb-4">
          <IconComponent size={24} className={`${iconColor} flex-shrink-0 mt-1`} />
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-bold">{title}</h3>
            {message && (
              <p className="text-sm text-gray-600 mt-1 whitespace-pre-line">
                {message}
              </p>
            )}
          </div>
          <button
            onClick={onClose}
            disabled={submitting}
            className="text-gray-400 hover:text-gray-600 disabled:opacity-30"
            aria-label={lang === 'tr' ? 'Kapat' : 'Close'}
            data-testid="confirm-modal-close"
          >
            <X size={20} />
          </button>
        </div>

        {children && (
          <div className="mb-4 mt-3">
            {children}
          </div>
        )}

        <div className="flex gap-2 justify-end mt-6">
          <button
            onClick={onClose}
            disabled={submitting}
            className="px-4 py-2 rounded-lg border-2 border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50"
            data-testid="confirm-modal-cancel"
          >
            {cancelText || (lang === 'tr' ? 'İptal' : 'Cancel')}
          </button>
          <button
            onClick={onConfirm}
            disabled={submitting}
            className={`px-4 py-2 rounded-lg text-white font-bold ${buttonColor} disabled:opacity-50`}
            data-testid="confirm-modal-confirm"
          >
            {submitting
              ? (lang === 'tr' ? 'İşlem yapılıyor...' : 'Processing...')
              : (confirmText || (lang === 'tr' ? 'Onayla' : 'Confirm'))}
          </button>
        </div>
      </div>
    </div>
  );
}
